import { Button, Grid, Typography } from '@mui/material';
import SubCarePlanList from '../../components/SubCarePlanList';
import IconButton from '../../components/IconButton';

function GeneratedInitialPlan({
	planData,
	expanded,
	handleExpansion,
	onPlanChange,
	onCreateNewPlan,
	selectedElder,
	onExportPlan,
	isLoading,
}) {
	return (
		<Grid container paddingLeft={'20px'} paddingRight={'20px'}>
			<Grid
				container
				bgcolor={'#FFFFFF'}
				borderRadius={'5px'}
				marginBottom={'10px'}
				alignItems={'center'}
				justifyContent={'space-between'}
				flexDirection={'row'}
				padding={'10px'}>
				<Typography
					fontSize={'16px'}
					color={
						'#28696D'
					}>{`Elder ID: ${selectedElder}`}</Typography>
				<Grid flexDirection={'column'}>
					<Button
						onClick={onExportPlan}
						sx={{
							backgroundColor: 'transparent',
							paddingX: '15px',
							paddingY: '4px',
							color: '#28696D',
							textTransform: 'none',
							marginRight: '10px',
							fontWeight: '600',
						}}>
						Export
					</Button>
					<IconButton
						text={'Create New Plan'}
						onClick={onCreateNewPlan}
					/>
				</Grid>
			</Grid>
			<Grid item width={'100%'}>
				<SubCarePlanList
					data={planData}
					expanded={expanded}
					handleExpansion={handleExpansion}
					onPlanChange={onPlanChange}
					isLoading={isLoading}
				/>
			</Grid>
		</Grid>
	);
}

export default GeneratedInitialPlan;
